import './Administracion.css'
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';
import {
    formatMoneda,
    getComparator, stableSort,
    EnhancedTableHead, validaSoloNumero, lpad
} from '../../util/varios';
import moment from 'moment';
import CatalogoCuentaBancaria from '../../catalogos/catalogoCuentasBancarias';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import Checkbox from '@mui/material/Checkbox';
import TablePagination from '@mui/material/TablePagination';
import { fontSize, textAlign, width } from '@mui/system';
import { AgregarFecha } from './modalAgregarFecha';

const TablaConciliacionBancaria = (props) => {
    var op = require('../../modulos/datos');
    const anioactu = JSON.parse(localStorage.getItem('anioactu'));
    let token = localStorage.getItem('jwtToken');

    const headCells = [
        { id: 'referencia', textAlign: 'center', label: 'Nº Docu.', width: '180px', align: "center", numeric: false, disablePadding: false },
        { id: 'tipodoc', textAlign: 'center', label: 'Tipo', width: '200px', align: "center", numeric: false, disablePadding: false },
        { id: 'fechaingreso', textAlign: 'center', label: 'Fecha Mov.', width: '180px', align: "center", numeric: false, disablePadding: false },
        { id: 'fecha', textAlign: 'center', label: 'Fecha Docu.', width: '180px', align: "center", numeric: false, disablePadding: false },
        { id: 'fechaedocta', textAlign: 'center', label: 'Fecha Edo. Cuenta.', width: '180px', align: "center", numeric: false, disablePadding: false },
        { id: 'monto', textAlign: 'center', label: 'Monto', width: '200px', align: "center", numeric: false, disablePadding: false },
        { id: 'concepto', textAlign: 'center', label: 'Concepto', width: '750px', align: "center", numeric: false, disablePadding: false }
    ]

    const headCells1 = [
        { id: 'referencia', label: 'Nº Docu.', width: '200px', textAlign: "center", numeric: false, disablePadding: false },
        { id: 'tipodoc', label: 'Tipo', width: '200px', textAlign: "center", numeric: false, disablePadding: false },
        { id: 'fechaingreso', label: 'Fecha', width: '200px', textAlign: "center", numeric: false, disablePadding: false },
        { id: 'monto', label: 'Monto', width: '200px', textAlign: "center", numeric: false, disablePadding: false },
        { id: 'concepto', label: 'Id Movimiento', width: '200px', textAlign: "center", numeric: false, disablePadding: false }
    ]

    const headCells2 = [
        { id: 'referencia', textAlign: 'center', label: 'Nº Docu.', width: '200px', align: "center", numeric: false, disablePadding: false },
        { id: 'tipodoc', textAlign: 'center', label: 'Tipo', width: '200px', align: "center", numeric: false, disablePadding: false },
        { id: 'fechaingreso', textAlign: 'center', label: 'Fecha.', width: '200px', align: "center", numeric: false, disablePadding: false },
        { id: 'fecha', textAlign: 'center', label: 'Fecha Conciliacion.', width: '200px', align: "center", numeric: false, disablePadding: false },
        { id: 'monto', textAlign: 'center', label: 'Monto', width: '200px', align: "center", numeric: false, disablePadding: false },
        { id: 'concepto', textAlign: 'center', label: 'Concepto', width: '750px', align: "center", numeric: false, disablePadding: false }
    ]

    const txtFechaConRef = useRef();
    const cmbMesRef = useRef();
    const cmbAnioRef = useRef();
    const cmbDiaRef = useRef();
    const txtSaldoAnterior = useRef();
    const txtDebito = useRef();
    const txtCredito = useRef();
    const txtSaldoActual = useRef();
    const txtIdCuenta = useRef();
    const txtNomBanco = useRef();
    const txtNumCuenta = useRef();
    const txtIdprov = useRef();
    const cmbTipoRef = useRef();

    const [fechaUD, setFechaUD] = useState();
    const [cmbDias, setCmbDias] = useState([]);

    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtBuscador = useRef();
    const txtBuscador1 = useRef();
    const txtBuscador2 = useRef();

    const [disabledInput, setDisabledInput] = useState(0);
    const [mostrar2, setMostrar2] = useState(false);
    const [activate, setActivate] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [mostrar6, setMostrar6] = useState(false);
    const [selected, setSelected] = React.useState([]);

    const [order, setOrder] = React.useState('asc');
    const [order1, setOrder1] = React.useState('asc');
    const [order2, setOrder2] = React.useState('asc');

    const [orderBy, setOrderBy] = React.useState('calories');
    const [orderBy1, setOrderBy1] = React.useState('calories');
    const [orderBy2, setOrderBy2] = React.useState('calories');

    // Estados de paginación para cada tabla
    const [page, setPage] = React.useState(0);
    const [page1, setPage1] = React.useState(0);
    const [page2, setPage2] = React.useState(0);

    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [rowsPerPage1, setRowsPerPage1] = React.useState(10);
    const [rowsPerPage2, setRowsPerPage2] = React.useState(10);

    const [records1, setRecords1] = useState([]);
    const [records2, setRecords2] = useState([]);

    const [filterFn2, setFilterFn2] = useState({ fn: items2 => { return items2; } })

    const [cmbAnios, setCmbAnios] = useState();
    const [cmbMeses, setCmbMeses] = useState();
    const [desde, setDesde] = useState(0);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [filterFn1, setFilterFn1] = useState({ fn: items1 => { return items1; } })
    const [selected1, setSelected1] = React.useState([]);
    const [selected2, setSelected2] = React.useState([]);

    const [dataSel, setDataSel] = useState();

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, records.length - page * rowsPerPage);
    const emptyRows1 = rowsPerPage1 - Math.min(rowsPerPage1, records1.length - page1 * rowsPerPage1);
    const emptyRows2 = rowsPerPage2 - Math.min(rowsPerPage2, records2.length - page2 * rowsPerPage2);

    const handleClick1 = (event, data) => {
        const selectedIndex = selected1.indexOf(data);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected1, data);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected1.slice(1));
        } else if (selectedIndex === selected1.length - 1) {
            newSelected = newSelected.concat(selected1.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected1.slice(0, selectedIndex),
                selected1.slice(selectedIndex + 1),
            );
        }
        setSelected1(newSelected);
    };

    const handleClick2 = (event, data) => {
        const selectedIndex = selected2.indexOf(data);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected2, data);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected2.slice(1));
        } else if (selectedIndex === selected2.length - 1) {
            newSelected = newSelected.concat(selected2.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected2.slice(0, selectedIndex),
                selected2.slice(selectedIndex + 1),
            );
        }
        setSelected2(newSelected);
    };

    const handleClick = (event, data) => {
        if (isSelected(data.idmovimientobancario)) {
            records[records.findIndex(x => x.idmovimientobancario === data.idmovimientobancario)].fechaedocta = '';
            const selectedIndex = selected.indexOf(data);
            let newSelected = [];
            if (selectedIndex === -1) {
                newSelected = newSelected.concat(selected, data);
            } else if (selectedIndex === 0) {
                newSelected = newSelected.concat(selected.slice(1));
            } else if (selectedIndex === selected.length - 1) {
                newSelected = newSelected.concat(selected.slice(0, -1));
            } else if (selectedIndex > 0) {
                newSelected = newSelected.concat(
                    selected.slice(0, selectedIndex),
                    selected.slice(selectedIndex + 1),
                );
            }
            setSelected(newSelected);
        } else {
            setDataSel(data);
            setMostrar6(true);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangePage1 = (event, newPage) => {
        setPage1(newPage);
    };

    // Manejador para la paginación de la tabla 3
    const handleChangePage2 = (event, newPage) => {
        setPage2(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeRowsPerPage1 = (event) => {
        setRowsPerPage1(parseInt(event.target.value, 10));
        setPage1(0);
    };

    // Manejador para cambiar filas por página de la tabla 3
    const handleChangeRowsPerPage2 = (event) => {
        setRowsPerPage2(parseInt(event.target.value, 10));
        setPage2(0);
    };

    const isSelected = (idmovimientobancario) => {
        for (let i = 0; i < selected.length; i++) {
            if (selected[i].idmovimientobancario === idmovimientobancario) {
                return true;
            }
        }
        return null;
    };

    const isSelected1 = (idmovimientobancario) => {
        for (let i = 0; i < selected1.length; i++) {
            if (selected1[i].idmovimientobancario === idmovimientobancario) {
                return true;
            }
        }
        return null;
    };

    const isSelected2 = (idmovimientosentransito) => {
        for (let i = 0; i < selected2.length; i++) {
            if (selected2[i].idmovimientosentransito === idmovimientosentransito) {
                return true;
            }
        }
        return null;
    };

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter((x) => {
                        if (
                            (x.numdoc !== null ? x.numdoc.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                            (x.descripcion !== null ? x.descripcion.toLowerCase().includes(target.value.toLowerCase()) : "") ||
                            (x.fecha !== null ? moment.utc(x.fecha).format('DD/MM/YYYY').includes(target.value) : "") ||
                            (x.fechadoc !== null ? moment.utc(x.fechadoc).format('DD/MM/YYYY').includes(target.value) : "") ||
                            (x.monto !== null ? formatMoneda(x.monto.replace(',', '').replace('.', ','), ',', '.', 2).includes(target.value) : "") ||
                            (x.concepto !== null ? x.concepto.toLowerCase().includes(target.value.toLowerCase()) : "")
                        ) {
                            return x;
                        }
                    });
                }
            }
        });
    }

    const handleSearch1 = e => {
        let target = e.target;
        setFilterFn1({
            fn: items1 => {
                if (target.value === "") {
                    return items1;
                } else {
                    let filteredItems = items1.filter(x => x.numdoc.includes(target.value));
                    if (filteredItems.length === 0) {
                        filteredItems = items1.filter(x =>
                            (x.fecha !== '' ? moment.utc(x.fecha).format('DD/MM/YYYY').includes(target.value) : '')
                            || (x.monto !== '' ? formatMoneda(x.monto.replace(',', '').replace('.', ','), ',', '.', 2).toLowerCase().includes(target.value) : '')
                            || (x.idmovimientobancario !== '' ? x.idmovimientobancario.includes(target.value) : '')
                        );
                    }
                    return filteredItems;
                }
            }
        });
    }

    const handleSearch2 = e => {
        let target = e.target;
        setFilterFn2({
            fn: items2 => {
                if (target.value === "") {
                    return items2;
                } else {
                    let filteredItems = items2.filter(x => x.numdoc.includes(target.value));
                    if (filteredItems.length === 0) {
                        filteredItems = items2.filter(x =>
                            (x.fechaconciliacion !== '' ? moment.utc(x.fechaconciliacion).format('DD/MM/YYYY').includes(target.value) : '')
                            || (x.fecha !== '' ? moment.utc(x.fecha).format('DD/MM/YYYY').includes(target.value) : '')
                            || (x.monto !== '' ? formatMoneda(x.monto.replace(',', '').replace('.', ','), ',', '.', 2).toLowerCase().includes(target.value) : '')
                            || (x.concepto !== '' ? x.concepto.toLowerCase().includes(target.value.toLowerCase()) : '')
                        );
                    }
                    return filteredItems;
                }
            }
        });
    }

    const handleSelectAllClick = (event, cual) => {
        console.log(event.target.checked)
        event.preventDefault()
        if (event.target.checked) {
            let fecha = cmbAnioRef.current.value + '-' + lpad(cmbMesRef.current.value, '0', 2) + '-' + lpad(cmbDiaRef.current.value, '0', 2);
            for (let i = 0; i < records.length; i++) {
                records[i].fechaedocta = fecha;
            }
            const newSelecteds = records.map((item) => item);
            console.log(newSelecteds)
            setSelected(newSelecteds);
            return;
        } else {
            for (let i = 0; i < records.length; i++) {
                records[i].fechaedocta = '';
            }
            setSelected([]);
        }
    };

    const handleSelectAllClick1 = (event) => {
        event.preventDefault()
        if (event.target.checked) {
            const newSelecteds = records1.map((item) => item);
            setSelected1(newSelecteds);
            return;
        }
        setSelected1([]);
    };

    const handleSelectAllClick2 = (event) => {
        event.preventDefault()
        if (event.target.checked) {
            const newSelecteds = records2.map((item) => item);
            setSelected2(newSelecteds);
            return;
        }
        setSelected2([]);
    };

    const generarDiasDelMes = (anio, mes) => {
        const ultimoDia = new Date(anio, mes, 0).getDate();
        const dias = [];
        for (let i = 1; i <= ultimoDia; i++) {
            dias.push(i);
        }
        return dias;
    };

    const validarPeriodo = (event) => {
        setDesde(0);
        setRecords([]);
        setRecords1([]);
        setRecords2([]);

        const anio = parseInt(cmbAnioRef.current.value);
        const mes = parseInt(cmbMesRef.current.value);

        const dias = generarDiasDelMes(anio, mes);
        setCmbDias(dias);

        if (event.target.id === 'dia') {
            cmbDiaRef.current.value = event.target.value;
        } else {
            cmbDiaRef.current.value = dias[dias.length - 1];
        }
        let dia = lpad(cmbDiaRef.current.value, '0', 2);
        let mes1 = lpad(cmbMesRef.current.value, '0', 2);
        let anio1 = cmbAnioRef.current.value;
        let fecha = anio1 + '-' + mes1 + '-' + dia;
        txtFechaConRef.current.value = moment.utc(fecha).format("YYYY-MM-DD");

        let fecPer = cmbAnioRef.current.value + '-' + cmbMesRef.current.value.toString().padStart(2, 0) + '-01';
        let fecUD = cmbAnioRef.current.value + '-' + lpad(cmbMesRef.current.value, '0', 2) + '-' + lpad(cmbDiaRef.current.value, '0', 2);
        if (fecPer > moment.utc(txtFechaConRef.current.value).format("YYYY-MM-DD")) {
            cmbMesRef.current.value = 1;
            cmbAnioRef.current.value = (new Date(txtFechaConRef.current.value)).getFullYear();

            const nuevosDias = generarDiasDelMes(cmbAnioRef.current.value, cmbMesRef.current.value);
            setCmbDias(nuevosDias);
            cmbDiaRef.current.value = nuevosDias[nuevosDias.length - 1];

            let fecUD = cmbAnioRef.current.value + '-' + lpad(cmbMesRef.current.value, '0', 2) + '-' + lpad(cmbDiaRef.current.value, '0', 2);
            setFechaUD(fecUD);
            return false;
        } else {
            setFechaUD(fecUD);
            return true;
        }
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleRequestSort1 = (event, property) => {
        const isAsc = orderBy1 === property && order1 === 'asc';
        setOrder1(isAsc ? 'desc' : 'asc');
        setOrderBy1(property);
    };

    const handleRequestSort2 = (event, property) => {
        const isAsc = orderBy2 === property && order2 === 'asc';
        setOrder2(isAsc ? 'desc' : 'asc');
        setOrderBy2(property);
    };

    const handleCloseSi = () => {
        setActivate(false);
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
    };

    useEffect(() => {
        LlenarComboAnio()
    }, []);

    const catalogoCuentaBancaria = (e) => {
        e.preventDefault();
        setMostrar5(true);
    };

    const seleccionarCuentaBancaria = (codigo) => {
        let campos = "*"
        let nomtab = "cuentabancaria";
        let nomid = "idcuentabancaria";
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${codigo}&nomtab=${nomtab}&nomid=${nomid}`
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                if (response.data.idcuentabancaria > 0) {
                    txtIdCuenta.current.value = response.data.idcuentabancaria;
                    txtNomBanco.current.value = response.data.nombre;
                    txtNumCuenta.current.value = response.data.cuentabancaria;
                    setDisabledInput(2)
                } else {
                    setMensaje({ mostrar: true, titulo: 'Error.', texto: '¡Código i/o Cuenta Bancaria, No esta Registrado!', icono: 'error' });
                    txtIdCuenta.current.value = '';
                    txtNomBanco.current.value = '';
                    txtNumCuenta.current.value = '';
                }
            }
        }).catch((error) => {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const handleInputNumChange = (event) => {
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            setDesde(0);
            setRecords([]);
            setRecords1([]);
            setRecords2([]);
            txtNomBanco.current.value = '';
            txtNumCuenta.current.value = '';
            if (event.which === 13) {
                if (event.target.id === 'idprov') {
                    txtIdprov.current.focus();
                } else if (event.target.id === 'idcuenta') {
                    txtIdCuenta.current.focus();
                }
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleCancelaCuentaBancaria = () => {
        setMostrar5(false);
    }

    const handleAceptarCuentaBancaria = (datos) => {
        setMostrar5(false);
        setDisabledInput(2)
        txtIdCuenta.current.value = datos.idcuentabancaria;
        txtNomBanco.current.value = datos.nombre;
        txtNumCuenta.current.value = datos.cuentabancaria;
    }

    const handleCuentaBancaria = (event) => {
        event.preventDefault();
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarCuentaBancaria(event.target.value);
            }
        }
    };

    const LlenarComboAnio = () => {
        var n = (new Date()).getFullYear();
        var a = [];
        for (var i = n; i >= 2015; i--) {
            a.push({ anio: i });
        }
        cmbAnioRef.current.value = n;
        setCmbAnios(a);
        var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
        var m = [];
        for (var x = 0; x < 12; x++) {
            m.push({ nummes: x + 1, mes: meses[x] });
        }
        cmbMesRef.current.value = 1;
        setCmbMeses(m);

        const dias = generarDiasDelMes(n, 1);
        setCmbDias(dias);
        let ultdia = dias[dias.length - 1].toString();
        cmbDiaRef.current.value = ultdia;
    };

    const seleccionarSaldos = () => {
        let idcuenta = txtIdCuenta.current.value;
        let anio = parseInt(cmbAnioRef.current.value);
        let fecha = " fechaconciliacion <= '" + anio + "-" + lpad(cmbMesRef.current.value, "0", 2) + "-01'";
        let endpoint = `${op.conexion}/api/administracion/seleccionarsaldos?idcuenta=${idcuenta}&cadefecha=${fecha}`
        setActivate(true)
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                txtSaldoAnterior.current.value = formatMoneda(response.data.saldoanterior.replace(',', '').replace('.', ','), ',', '.', 2)
                seleccionarSaldos2(response.data.saldoanterior);
            }
        }).catch((error) => {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const seleccionarSaldos2 = (anterior) => {
        let idcuenta = txtIdCuenta.current.value;
        let anio = parseInt(cmbAnioRef.current.value);
        let ndias = new Date(anio, parseInt(cmbMesRef.current.value), 0).getDate();
        let ini = anio + '-' + lpad(cmbMesRef.current.value, '0', 2) + '-01';
        let fin = anio + '-' + lpad(cmbMesRef.current.value, '0', 2) + '-' + lpad(ndias.toString(), '0', 2);

        let fecha = " fechaconciliacion >= '" + ini + "' AND fechaconciliacion <= '" + fin + "'";
        let endpoint = `${op.conexion}/api/administracion/seleccionarsaldos?idcuenta=${idcuenta}&cadefecha=${fecha}`
        setActivate(true)
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                let saldo = parseFloat(anterior) + parseFloat(response.data.montocredito);
                let saldo2 = parseFloat(saldo * 100) / 100;

                let saldoActu = parseFloat(saldo2) - parseFloat(response.data.montodebito);
                let saldoActu2 = parseFloat(saldoActu * 100) / 100;

                txtDebito.current.value = formatMoneda(response.data.montodebito.replace(',', '').replace('.', ','), ',', '.', 2)
                txtCredito.current.value = formatMoneda(response.data.montocredito.replace(',', '').replace('.', ','), ',', '.', 2)
                txtSaldoActual.current.value = formatMoneda(parseFloat(saldoActu2).toString().replace(',', '').replace('.', ','), ',', '.', 2)

                seleccionarMovimientosCuentasBancarias();
            }
        }).catch((error) => {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const seleccionar_movimientosentransito = () => {
        let idcue = txtIdCuenta.current.value;
        let cadetipo = cmbTipoRef.current.value;
        let anio = parseInt(cmbAnioRef.current.value);
        let ndias = new Date(anio, parseInt(cmbMesRef.current.value), 0).getDate();
        let fecha = " fecha <= '" + anio + "-" + lpad(cmbMesRef.current.value, "0", 2) + "-" + lpad(ndias.toString(), "0", 2) + "'";
        let endpoint = `${op.conexion}/api/administracion/seleccionarmovitransito?idcue=${idcue}&cadetipo=${cadetipo}&cadefecha=${fecha}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                setRecords2(response.data)
                setActivate(false)
            }
        }).catch((error) => {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const seleccionarMovimientosCuentasBancarias = () => {
        let idcue = txtIdCuenta.current.value;
        let cadetipo = cmbTipoRef.current.value;
        let anio = parseInt(cmbAnioRef.current.value);
        let ndias = new Date(anio, parseInt(cmbMesRef.current.value), 0).getDate();
        let ndias2 = "01";
        let nmes = "01";
        let fecha = `'fecha <= ' || quote_literal('${anio}-${lpad(cmbMesRef.current.value, "0", 2)}-${lpad(ndias.toString(), "0", 2)}') || ' AND fecha >= ' || quote_literal('${anio-2}-${lpad(nmes, "0", 2)}-${lpad(ndias2.toString(), "0", 2)}')`;
        //let fecha = `'fecha <= ' || quote_literal('${anio}-${lpad(cmbMesRef.current.value, "0", 2)}-${lpad(ndias.toString(), "0", 2)}')`;
        let nConci = 0;
        let endpoint = `${op.conexion}/api/administracion/seleccionarmoviconciliacion?idcue=${idcue}&cadetipo=${cadetipo}&cadefecha=${fecha}&nConci=${nConci}`;

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                let movConciliacion = [...response.data];
                for (let i = 0; i < movConciliacion.length; i++) {
                    movConciliacion[i].fechaedocta = movConciliacion[i].fechaedocta;
                }

                setRecords(movConciliacion)
                seleccionarMovimientosCuentasBancariasConciliacion()
            }
        }).catch((error) => {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const seleccionarMovimientosCuentasBancariasConciliacion = () => {
        let idcue = txtIdCuenta.current.value;
        let cadetipo = cmbTipoRef.current.value;
        let anio = parseInt(cmbAnioRef.current.value) - 1
        let fecha = `'fecha >= ' || quote_literal('${anio}-01-01')`;
        let nConci = 1;
        let endpoint = `${op.conexion}/api/administracion/seleccionarmoviconciliacion?idcue=${idcue}&cadetipo=${cadetipo}&cadefecha=${fecha}&nConci=${nConci}`;
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                setRecords1(response.data)
                seleccionar_movimientosentransito()
            }
        }).catch((error) => {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const seleccionarDetalles = () => {
        setSelected([])
        setSelected1([])
        setSelected2([])
        setRecords([])
        setRecords1([])
        setRecords2([])
        seleccionarSaldos()
    }

    const procesar = (body) => {
        setActivate(true)
        let endpoint = `${op.conexion}/api/administracion/actualizarconciliacion`;
        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                cancelar()
                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Conciliación Exitosa', icono: 'exito' });
                setActivate(false)
            }
        }).catch((error) => {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const conciliarMovimientos = () => {
        if (selected.length === 0 && selected1.length === 0 && selected2.length === 0) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: 'Debe seleccionar movimientos para conciliar.', icono: 'error' });
            return;
        }
        let movPorCon = selected;
        let movCon = selected1;
        let movTran = selected2;
        let id = txtIdCuenta.current.value;
        let fechaconci = fechaUD;
        let body = {
            id,
            movPorCon,
            movCon,
            movTran,
            fechaconci
        }
        procesar(body);
    }

    const cancelar = () => {
        setDisabledInput(0);
        setSelected([])
        setSelected1([])
        setSelected2([])
        setRecords([])
        setRecords1([])
        setRecords2([])
        txtBuscador.current.value = '';
        txtBuscador1.current.value = '';
        txtBuscador2.current.value = '';
        txtFechaConRef.current.value = '';
        txtIdCuenta.current.value = '';
        txtNumCuenta.current.value = '';
        txtNomBanco.current.value = ''
        cmbAnioRef.current.value = anioactu;
        cmbMesRef.current.value = 1;

        const dias = generarDiasDelMes(anioactu, 1);
        setCmbDias(dias);
        cmbDiaRef.current.value = dias[dias.length - 1];

        cmbTipoRef.current.value = 0;
        txtCredito.current.value = '';
        txtDebito.current.value = '';
        txtSaldoActual.current.value = '';
        txtSaldoAnterior.current.value = '';
    }

    const desbloquear = () => {
        setDisabledInput(1);
        let dia = lpad(cmbDias[cmbDias.length - 1].toString(), '0', 2);
        let mes = lpad(cmbMesRef.current.value, '0', 2);
        let anio = cmbAnioRef.current.value;
        let fecha = anio + '-' + mes + '-' + dia;
        setFechaUD(fecha);
        txtFechaConRef.current.value = moment.utc(fecha).format("YYYY-MM-DD");
        cmbDiaRef.current.value = dia;
        txtIdCuenta.current.focus()
    }

    const cerrar = () => {
        props.setTabla(0);
    };

    const aceptarAgregarFecha = (fecha) => {
        setMostrar6(false);
        records[records.findIndex(x => x.idmovimientobancario === dataSel.idmovimientobancario)].fechaedocta = fecha;
        const selectedIndex = selected.indexOf(dataSel);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, dataSel);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    }

    return (
        <div className='col-md-12 row px-4 mx-auto mt-2 row'>
            <div className='header-azulGradiant'>
                <h3 className='text-light fs-4 m-0 fw-bold'>
                    Gestionar Conciliación Bancaria
                </h3>
                <a type='button'
                    onClick={cerrar}
                    className='bg-transparent text-light fw-bold d-flex gap-2 align-items-center'>
                    salir
                    <i className="fas fa-times"></i>
                </a>
            </div>

            <div className='col-md-12 row mx-auto m-0 mb-2'>
                <div className="input-group input-group-sm m-0 px-0 col-3 mt-2">
                    <label className="input-group-text" id="inputGroup-sizing-sm">
                        Fecha de Conciliación:
                    </label>
                    <input
                        autoComplete="off"
                        type="date"
                        className="form-control col-12 px-1"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        disabled
                        ref={txtFechaConRef}
                    />
                </div>
                <div className="input-group input-group-sm m-0 col-9"></div>
                <fieldset className="col-md-5 border-azul rounded m-0 p-2 d-flex">
                    <legend className="float-none m-0 w-auto fw-bold">
                        Datos del Banco
                    </legend>
                    <div className="col-12 input-group input-group-sm m-0 p-0">
                        <label className="input-group-text">
                            Código:
                        </label>
                        <input type="text"
                            placeholder='Cod.'
                            className="form-control text-uppercase col-md-1"
                            disabled={disabledInput === 1 ? false : disabledInput === 2 ? false : true}
                            onChange={handleInputNumChange}
                            onKeyUp={handleCuentaBancaria}
                            onBlur={handleCuentaBancaria}
                            ref={txtIdCuenta}
                            id="idcuenta" />
                        <button
                            onClick={catalogoCuentaBancaria}
                            disabled={disabledInput === 1 ? false : disabledInput === 2 ? false : true}
                            className="btn btn-sm  btn-info border shadow-none">
                            <i className="fa fa-search"></i>
                        </button>

                        <input type="text"
                            placeholder="Nombre"
                            className="form-control text-uppercase "
                            maxLength={12}
                            disabled={true}
                            ref={txtNomBanco}
                            id="inputDireccion" />
                        <input type="text"
                            placeholder="0000-000000-00000000000"
                            className="form-control text-uppercase "
                            ref={txtNumCuenta}
                            disabled={true}
                            id="inputDireccion" />
                    </div>
                </fieldset>
                <fieldset className="col-md-7 border-azul rounded m-0 p-2 d-flex justify-content-between">
                    <legend className="float-none m-0 w-auto" >
                        Periodo a Conciliar
                    </legend>
                    <div className="col-3 input-group input-group-sm p-0 m-0">
                        <label className="input-group-text" >
                            Mes:
                        </label>
                        <select name=""
                            className='form-select '
                            disabled={disabledInput === 2 ? false : true}
                            ref={cmbMesRef}
                            onChange={validarPeriodo}>
                            {cmbMeses && cmbMeses.map(meses => (
                                <option key={meses.nummes} value={meses.nummes}>{meses.mes}</option>
                            ))};
                        </select>
                    </div>
                    <div className="col-2 input-group input-group-sm p-0 m-0">
                        <label className="input-group-text" >
                            Día:
                        </label>
                        <select name=""
                            className='form-select '
                            disabled={disabledInput === 2 ? false : true}
                            id="dia"
                            ref={cmbDiaRef}
                            onChange={validarPeriodo}>
                            {cmbDias && cmbDias.map(dia => (
                                <option key={dia} value={dia}>{dia}</option>
                            ))};
                        </select>
                    </div>
                    <div className="col-2 input-group input-group-sm p-0 px-2 m-0">
                        <label className="input-group-text">
                            Año:
                        </label>
                        <select className='form-select '
                            disabled={disabledInput === 2 ? false : true}
                            id="anio"
                            ref={cmbAnioRef}
                            onChange={validarPeriodo}>
                            {cmbAnios && cmbAnios.map(anios => (
                                <option key={anios.anio} value={anios.anio}>{anios.anio}</option>
                            ))};
                        </select>
                    </div>
                    <div className="input-group input-group-sm p-0 m-0">
                        <label className="input-group-text">
                            Tipo Movimiento:
                        </label>
                        <select name=""
                            id="anio"
                            className='form-select '
                            disabled={disabledInput === 2 ? false : true}
                            ref={cmbTipoRef}
                            onChange={validarPeriodo}  >
                            <option value="0">Todos</option>
                            <option value="14">Egreso</option>
                            <option value="15">Depósito</option>
                            <option value="16">Nota de Débito</option>
                            <option value="17">Nota de Credito</option>
                        </select>
                        <button disabled={disabledInput === 2 ? false : true}
                            onClick={seleccionarDetalles}
                            className="btn btn-sm btn-info border shadow-none" >
                            <i className="fa fa-search"></i>
                        </button>
                    </div>
                </fieldset>

                <fieldset className="col-12 border-azul rounded p-2 m-0 d-flex">
                    <legend className="float-none m-0 w-auto fw-bold">
                        Saldos en Cuentas
                    </legend>
                    <div className="col-3 input-group input-group-sm m-0 p-0">
                        <label className="input-group-text">
                            Saldo Anterior:
                        </label>
                        <input type="text"
                            ref={txtSaldoAnterior}
                            placeholder='0,00'
                            className="form-control text-uppercase text-right "
                            disabled
                            id="idcuenta" />
                    </div>
                    <div className="col-3 input-group input-group-sm m-0 p-0 px-2">
                        <label className="input-group-text" >
                            Debito:
                        </label>
                        <input type="text"
                            ref={txtDebito}
                            placeholder='0,00'
                            className="form-control text-uppercase text-right "
                            disabled
                            id="idcuenta" />
                    </div>
                    <div className="col-3 input-group input-group-sm m-0 p-0 px-2">
                        <label className="input-group-text" >
                            Credito:
                        </label>
                        <input type="text"
                            ref={txtCredito}
                            placeholder='0,00'
                            className="form-control text-uppercase text-right "
                            disabled
                            id="idcuenta" />
                    </div>
                    <div className="col-3 input-group input-group-sm m-0 p-0">
                        <label className="input-group-text" >
                            Saldo Actual:
                        </label>
                        <input type="text"
                            ref={txtSaldoActual}
                            placeholder='0,00'
                            className="form-control text-uppercase text-right "
                            disabled
                            id="idcuenta" />
                    </div>
                </fieldset>
            </div>

            <ul className="col-12 nav nav-pills p-0 px-4 m-0 mb-2"
                id="ex-with-icons"
                role="tablist">
                <li className="nav-item col-4 m-0 p-0" role="presentation">
                    <a className='nav-link text-center fw-bold active'
                        id="datosTributarios"
                        data-bs-toggle="tab"
                        type='button'
                        data-bs-target="#tributarios"
                        role="tab"
                        aria-controls="tributarios"
                        aria-selected='true'>
                        Movimientos por Conciliar
                    </a>
                </li>
                <li className="nav-item col-4 m-0 p-0" role="presentation">
                    <a className='nav-link text-center fw-bold'
                        id="datosTributarios2"
                        data-bs-toggle="tab"
                        type='button'
                        data-bs-target="#tributarios2"
                        role="tab"
                        aria-controls="tributarios2"
                        aria-selected='false'>
                        Movimientos Conciliados
                    </a>
                </li>
                <li className="nav-item col-4 m-0 p-0" role="presentation">
                    <a className='nav-link text-center fw-bold'
                        id="datosTributarios3"
                        data-bs-toggle="tab"
                        type='button'
                        data-bs-target="#tributarios3"
                        role="tab"
                        aria-controls="tributarios3"
                        aria-selected='false'>
                        Movimientos en Trancitos
                    </a>
                </li>
            </ul>
            <div className="w-100 col-12 tab-content p-0 px-4 m-0" id="myTabContent">
                {/* Tabla 1 - Movimientos por Conciliar */}
                <div className='tab-pane fade show active'
                    id="tributarios"
                    role="tabpanel"
                    aria-labelledby="datosTributarios">
                    <div>
                        <div className="col-12 m-0 p-0 px-4 mb-2">
                            <input type="text" className="search-input col-5 form-control text-uppercase form-control-sm rounded-pill" ref={txtBuscador} onChange={handleSearch} placeholder="Buscar" />
                        </div>
                        <TableContainer>
                            <Table>
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={handleSelectAllClick}
                                    onRequestSort={handleRequestSort}
                                    rowCount={records.length}
                                    headCells={headCells}
                                />
                            </Table>
                        </TableContainer>
                        <Paper style={{
                            width: '100%',
                            marginBottom: '10px',
                            maxHeight: '150px',
                            overflowY: 'scroll'
                        }}>
                            <TableContainer>
                                <Table
                                    style={{
                                        minWidth: 750,
                                    }}
                                    aria-labelledby="tableTitle"
                                    size="small"
                                    aria-label="enhanced table">
                                    <tbody>
                                        {stableSort(filterFn.fn(records), getComparator(order, orderBy))
                                            //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row, index) => {
                                                const isItemSelected = isSelected(row.idmovimientobancario);
                                                const labelId = `enhanced-table-checkbox-${index}`;

                                                return (
                                                    <tr
                                                        hover
                                                        onClick={(event) => handleClick(event, row)}
                                                        role="checkbox"
                                                        aria-checked={isItemSelected}
                                                        tabIndex={-1}
                                                        key={row.idmovimientobancario}
                                                        selected={isItemSelected}
                                                    >
                                                        <td style={{ width: '20px' }} padding="checkbox">
                                                            <Checkbox
                                                                checked={isItemSelected}
                                                                color="primary"
                                                                inputProps={{ 'aria-labelledby': labelId }}
                                                            />
                                                        </td>
                                                        <td style={{ width: '180px' }} align="center">{row.numdoc}</td>
                                                        {/*<td style={{ width: '200px', fontSize: '13px' }} align="center">{row.tipo === 14 ? 'EGRESO' : row.tipo === 15 ? 'DEPOSITO' : row.tipo === 16 ? 'NOTA DE DEBITO' : 'NOTA DE CREDITO'}</td>*/}
                                                        <td style={{ width: '200px', fontSize: '13px' }} align="center">{row.descripcion.trim()}</td>
                                                        <td style={{ width: '180px' }} align="center">{moment.utc(row.fecha).format('DD/MM/YYYY')}</td>
                                                        <td style={{ width: '180px' }} align="center">{moment.utc(row.fechadoc).format('DD/MM/YYYY')}</td>
                                                        <td style={{ width: '180px' }} align="center">{row.fechaedocta === '' ? '' : moment.utc(row.fechaedocta).format('DD/MM/YYYY')}</td>
                                                        <td style={{ width: '200px', fontSize: '13px' }} align="right">{formatMoneda(row.monto.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                                        <td style={{ width: '750px', fontSize: '13px' }} className='pl-3' align="left">
                                                            {row.concepto}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        {emptyRows > 0 && (
                                            <tr style={{ height: (dense ? 33 : 53) * emptyRows }}>
                                                <td colSpan={7} />
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        {/* <TablePagination
                            rowsPerPageOptions={[10, 15, 20]}
                            component="div"
                            count={records.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        /> */}
                    </div>
                </div>

                {/* Tabla 2 - Movimientos Conciliados */}
                <div className='tab-pane fade'
                    id="tributarios2"
                    role="tabpanel"
                    aria-labelledby="datosTributarios2">
                    <div>
                        <div className="col-12 m-0 p-0 px-4 mb-2">
                            <input type="text" className="col-5 form-control text-uppercase form-control-sm rounded-pill" ref={txtBuscador1} onChange={handleSearch1} placeholder="Buscar" />
                        </div>
                        <TableContainer>
                            <Table>
                                <EnhancedTableHead
                                    numSelected={selected1.length}
                                    order={order1}
                                    orderBy={orderBy1}
                                    onSelectAllClick={handleSelectAllClick1}
                                    onRequestSort={handleRequestSort1}
                                    rowCount={records1.length}
                                    headCells={headCells1}
                                />
                            </Table>
                        </TableContainer>
                        <Paper style={{
                            width: '100%',
                            marginBottom: '10px',
                            maxHeight: '150px',
                            overflowY: 'scroll'
                        }}>
                            <TableContainer>
                                <Table
                                    aria-labelledby="tableTitle"
                                    size="small"
                                    aria-label="enhanced table">
                                    <tbody>
                                        {stableSort(filterFn1.fn(records1), getComparator(order1, orderBy1))
                                            //.slice(page1 * rowsPerPage1, page1 * rowsPerPage1 + rowsPerPage1)
                                            .map((row, index) => {
                                                const isItemSelected1 = isSelected1(row.idmovimientobancario);
                                                const labelId1 = `enhanced-table-checkbox-${index}`;
                                                return (
                                                    <tr
                                                        hover
                                                        onClick={(event) => handleClick1(event, row)}
                                                        role="checkbox"
                                                        aria-checked={isItemSelected1}
                                                        tabIndex={-1}
                                                        key={row.idmovimientobancario}
                                                        selected={isItemSelected1}
                                                    >
                                                        <td style={{ width: '20px' }} padding="checkbox">
                                                            <Checkbox
                                                                color="primary"
                                                                checked={isItemSelected1}
                                                                inputProps={{ 'aria-labelledby': labelId1 }}
                                                            />
                                                        </td>
                                                        <td style={{ width: '200px' }} align="center">{row.numdoc}</td>
                                                        <td style={{ width: '200px', fontSize: '10px' }} align="center">{row.tipo === 14 ? 'EGRESO' : row.tipo === 15 ? 'DEPOSITO' : row.tipo === 16 ? 'NOTA DE DEBITO' : 'NOTA DE CREDITO'}</td>
                                                        <td style={{ width: '200px' }} align="center">{moment.utc(row.fecha).format('DD/MM/YYYY')}</td>
                                                        <td style={{ width: '200px' }} align="right">{formatMoneda(row.monto.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                                        <td style={{ width: '200px' }} align="center">{row.idmovimientobancario}</td>
                                                    </tr>
                                                );
                                            })}
                                        {emptyRows1 > 0 && (
                                            <tr style={{ height: (dense ? 33 : 53) * emptyRows1 }}>
                                                <td colSpan={6} />
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        {/* <TablePagination
                            rowsPerPageOptions={[10, 15, 20]}
                            component="div"
                            count={records1.length}
                            rowsPerPage={rowsPerPage1}
                            page={page1}
                            onPageChange={handleChangePage1}
                            onRowsPerPageChange={handleChangeRowsPerPage1}
                        /> */}
                    </div>
                </div>

                {/* Tabla 3 - Movimientos en Tránsito - CORREGIDA */}
                <div className='tab-pane fade'
                    id="tributarios3"
                    role="tabpanel"
                    aria-labelledby="datosTributarios3">
                    <div>
                        <div className="col-12 m-0 p-0 px-4 mb-2">
                            <input type="text" className="col-5 form-control text-uppercase form-control-sm rounded-pill" ref={txtBuscador2} onChange={handleSearch2} placeholder="Buscar" />
                        </div>
                        <TableContainer>
                            <Table>
                                <EnhancedTableHead
                                    numSelected={selected2.length}
                                    order={order2}
                                    orderBy={orderBy2}
                                    onSelectAllClick={handleSelectAllClick2}
                                    onRequestSort={handleRequestSort2}
                                    rowCount={records2.length}
                                    headCells={headCells2}
                                    verificacion={0}
                                />
                            </Table>
                        </TableContainer>
                        <Paper style={{
                            width: '100%',
                            marginBottom: '10px',
                            maxHeight: '150px',
                            overflowY: 'scroll'
                        }}>
                            <TableContainer>
                                <Table
                                    aria-labelledby="tableTitle"
                                    size="small"
                                    aria-label="enhanced table">
                                    <tbody>
                                        {stableSort(filterFn2.fn(records2), getComparator(order2, orderBy2))
                                            //.slice(page2 * rowsPerPage2, page2 * rowsPerPage2 + rowsPerPage2)
                                            .map((row, index) => {
                                                const isItemSelected2 = isSelected2(row.idmovimientosentransito);
                                                const labelId2 = `enhanced-table-checkbox-${index}`;

                                                return (
                                                    <tr
                                                        hover
                                                        onClick={(event) => handleClick2(event, row)}
                                                        role="checkbox"
                                                        aria-checked={isItemSelected2}
                                                        tabIndex={-1}
                                                        key={row.idmovimientosentransito}
                                                        selected={isItemSelected2}
                                                    >
                                                        {/*<td style={{ width: '20px' }} padding="checkbox">
                                                            <Checkbox
                                                                color="primary"
                                                                checked={isItemSelected2}
                                                                inputProps={{ 'aria-labelledby': labelId2 }}
                                                            />
                                                        </td>*/}
                                                        <td style={{ width: '200px' }} align="center">{row.numdoc}</td>
                                                        <td style={{ width: '200px', fontSize: "13px" }} align="center">{row.tipo === 14 ? 'EGRESO' : row.tipo === 15 ? 'DEPOSITO' : row.tipo === 16 ? 'NOTA DE DEBITO' : 'NOTA DE CREDITO'}</td>
                                                        <td style={{ width: '200px' }} align="center">{moment.utc(row.fecha).format('DD/MM/YYYY')}</td>
                                                        <td style={{ width: '200px' }} align="center">{row.fechaconciliacion === null ? '' : moment.utc(row.fechaconciliacion).format('DD/MM/YYYY')}</td>
                                                        <td style={{ width: '200px' }} align="right">{formatMoneda(row.monto.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                                        <td style={{ width: '750px', fontSize: "13px" }} className='pl-3' align="left">
                                                            {row.concepto}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        {emptyRows2 > 0 && (
                                            <tr style={{ height: (dense ? 33 : 53) * emptyRows2 }}>
                                                <td colSpan={7} />
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        <TablePagination
                            rowsPerPageOptions={[10, 15, 20]}
                            component="div"
                            count={records2.length}
                            rowsPerPage={rowsPerPage2}
                            page={page2}
                            onPageChange={handleChangePage2}
                            onRowsPerPageChange={handleChangeRowsPerPage2}
                        />
                    </div>
                </div>
            </div>

            {disabledInput === 0 ?
                <div className='footer-azulGradiant col-md-12 d-flex justify-content-end'>
                    <button type="button"
                        className="btn btn-sm btn-primary rounded-pill m-4"
                        onClick={desbloquear}>
                        <i className="fas fa-sync-alt"></i> Conciliar
                    </button>
                </div> :
                <div className='footer-azulGradiant col-md-12 d-flex justify-content-end'>
                    <button type="button"
                        className="btn-sm rounded-pill btn btn-success col-md-2 m-4"
                        disabled={disabledInput === 1 ? false : disabledInput === 2 ? false : true}
                        onClick={conciliarMovimientos}>
                        <i className="fas fa-check-circle"></i> Aceptar
                    </button>
                    <button type="button"
                        className="btn-sm rounded-pill btn btn-danger col-md-2 m-4"
                        disabled={disabledInput === 1 ? false : disabledInput === 2 ? false : true}
                        onClick={cancelar}>
                        Cancelar
                    </button>
                </div>
            }

            <CatalogoCuentaBancaria
                show={mostrar5}
                onHideCancelar={handleCancelaCuentaBancaria}
                onHideAceptaCatalogo={handleAceptarCuentaBancaria} />

            <Dimmer active={activate} inverted />
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })}
                onHideSi={handleCloseSi} />
            <AgregarFecha
                show={mostrar6}
                onHideAceptar={aceptarAgregarFecha}
                onHideCancelar={() => {
                    setMostrar6(false)

                }}
                fecha={fechaUD}
            />
        </div>
    );
}

export default TablaConciliacionBancaria;